import moment from 'moment'
import { getColumnasCodigosDeCupo } from '../../../../Cupos/containers/consultaCodigoDeCupos/actions/constantesConsultaCodigoDeCupos'
import { TABLA_CODIGO_DE_CUPOS } from '../../../../../config/tables'
import { CodigoDeCupo } from '../../../../../models/cupo/codigoDeCupo'

export function parseDataSinConsumir (data) {
  const parsedData = []
  const hoy = moment(new Date()).format('YYYY-MM-DD')

  if (data) {
    for (const entry of data) {
      if (entry.fechaCupo === hoy && entry.estadoCupoStopq === '' && !entry.estadoCupoStopq.startsWith('Consum')) {
        const estado = 'Sin consumir'

        const dataCTG = {
          estado: estado,
          estadoCupoStopq: entry.estadoCupoStopq
        }

        parsedData.push({ ...entry, estado: estado, dataCTG: dataCTG })
      }
    }
  }
  return parsedData
}

export function cargarTablaSinConsumir (d, rol, filtroInicial) {
  return (dispatch) => {
    const data = parseDataSinConsumir(d)
    // const displayFechaN = false
    const textRowCount = 'Cantidad: '
    const customToolbar = null
    const columnas = getColumnasCodigosDeCupo(rol)
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: columnas,
        data: data,
        title: `Códigos de cupo`,
        isLoading: false,
        fixed2Decimales: false,
        extraOptions: {
          customToolbar,
          print: false,
          pagination: false,
          tableBodyMaxHeight: '499px',
          showRowCount: true,
          textRowCount,
          filtroInicial
        }
      },
      id: TABLA_CODIGO_DE_CUPOS
    })
  }
}

export function actualizarCuposSinConsumir (fechaD, fechaH, cereal = null, rol = null, filtroInicial = null, arribo = null) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CODIGO_DE_CUPOS
    })

    const sinConsumir = state.dashboard.codigosDeCupo || null

    if (sinConsumir && cereal) {
      const d = arribo ? sinConsumir.filter((c) => c.cereal === cereal && c.arribo === arribo) : sinConsumir.filter((c) => c.cereal === cereal)
      dispatch(cargarTablaSinConsumir(d, rol, filtroInicial))
    } else {
      CodigoDeCupo.getDataTablaConsultaCodigoDeCuposFiltrada(fechaD, fechaH, cereal, arribo)
        .then((data) => {
          const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
          dispatch({ type: 'RECEIVE_CODIGOS_DE_CUPO', data, fecha })
          dispatch(cargarTablaSinConsumir(data, rol, filtroInicial))
        })
    }
  }
}
